// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1A9ts","header":"PatientBlock_header__2Ncdq","label":"PatientBlock_label__1To0a","option":"PatientBlock_option__16js5"};